export const AUTOSUGGEST_URL_PREFIX = "/ifx/api/autosuggest";
export const AUTOSUGGEST_URL_SUFFIX = ".do";
